<h2 class="main-title text-center">{{ 'CUSTOMIZATION.JERSEY.TITLE' | translate }}</h2>

<div class="row m-0 mt-2 justify-content-center">
  <div class="col-12 col-lg-6 mt-4 position-relative svg-container p-0">
    <div class="svgShirt">
      <div inlineSVG="assets/img/customize/t-shirt.svg" *ngIf="shirtSelections.jersyType === 'raglan'" #svgContainer>
      </div>
      <img [src]="shirtSelections.logoPath" class="position-absolute main-logo" />
      <div inlineSVG="assets/img/customize/t-shirtType2.svg" *ngIf="shirtSelections.jersyType === 'basic'"
        #svgContainer></div>
    </div>
  </div>

  <div class="col-12 col-lg-6 mt-4 px-4">
    <div class="card p-4">
      <!-- Jersey Type -->
      <div class="mb-4">
        <label class="form-label d-block">{{ 'CUSTOMIZATION.JERSEY.TYPE' | translate }}</label>
        <div class="d-flex flex-wrap gap-2">
          <button id="raglanButton" class="btn btn-outline-dark"
            [ngClass]="{ active: shirtSelections.jersyType === 'raglan' }" (click)="applyJersyType('raglan')">
            {{ 'CUSTOMIZATION.JERSEY.RAGLAN' | translate }}
          </button>
          <button id="basicButton" class="btn btn-outline-dark"
            [ngClass]="{ active: shirtSelections.jersyType === 'basic' }" (click)="applyJersyType('basic')">
            {{ 'CUSTOMIZATION.JERSEY.BASIC' | translate }}
          </button>
        </div>
      </div>

      <!-- Collar -->
      <div class="mb-4">
        <label class="form-label">{{ 'CUSTOMIZATION.JERSEY.COLLAR' | translate }}</label>
        <div id="collarColor" class="d-flex flex-wrap gap-2">
          <span [id]="color + '-collar'" *ngFor="let color of colors" [ngStyle]="{ background: color }"
            class="color-circle" [ngClass]="{ active: shirtSelections.collarColor === color }"
            (click)="applyCollarColor(color)"></span>
        </div>
        <div *ngIf="hasError('SHIRT.COLLAR_COLOR_REQUIRED')" class="text-danger mt-2">
          {{ 'CUSTOMIZATION.VALIDATION.COLLAR_COLOR_REQUIRED' | translate }}
        </div>
      </div>

      <!-- Front Collar -->
      <div id="frontCollarColor" class="mb-4"
        *ngIf="['C1','C4','C5','C11','C15', 'C16', 'C19' ,'C14'].includes(shirtSelections.collarType)">
        <label class="form-label">{{ 'CUSTOMIZATION.JERSEY.FRONT_COLLAR' | translate }}</label>
        <div class="d-flex flex-wrap gap-2">
          <span [id]="color + '-frontCollar'" *ngFor="let color of colors" [ngStyle]="{ background: color }"
            class="color-circle" [ngClass]="{ active: shirtSelections.FrontCollarColor === color }"
            (click)="applyFrontCollarColor(color)"></span>
        </div>
      </div>

      <!-- Collar Type -->
      <div class="mb-4">
        <label class="form-label">{{ 'CUSTOMIZATION.JERSEY.COLLAR_TYPE' | translate }}</label>
        <div class="d-flex flex-wrap gap-2">
          <button [id]="type" *ngFor="let type of collarTypes" class="btn btn-outline-dark"
            [ngClass]="{ active: shirtSelections.collarType === type }" (click)="changeCollarType(type)">
            {{ type }}
          </button>
        </div>
      </div>

      <!-- Shoulder -->
      <div class="mb-4">
        <label class="form-label">{{ 'CUSTOMIZATION.JERSEY.SHOULDER' | translate }}</label>
        <div class="d-flex flex-wrap gap-2">
          <span [id]="color + '-shoulder'" *ngFor="let color of colors" [ngStyle]="{ background: color }"
            class="color-circle" [ngClass]="{ active: shirtSelections.shoulderColor === color }"
            (click)="applyShoulderColor(color)"></span>
        </div>
        <div *ngIf="hasError('SHIRT.SHOULDER_COLOR_REQUIRED')" class="text-danger mt-2">
          {{ 'CUSTOMIZATION.VALIDATION.SHOULDER_COLOR_REQUIRED' | translate }}
        </div>
      </div>

      <!-- Body -->
      <div class="mb-4">
        <label class="form-label">{{ 'CUSTOMIZATION.JERSEY.BODY' | translate }}</label>
        <div class="d-flex flex-wrap gap-2">
          <span [id]="color + '-body'" *ngFor="let color of colors" [ngStyle]="{ background: color }"
            class="color-circle" [ngClass]="{ active: shirtSelections.bodyColor === color }"
            (click)="applyBodyColor(color)"></span>
        </div>
        <div *ngIf="hasError('SHIRT.BODY_COLOR_REQUIRED')" class="text-danger mt-2">
          {{ 'CUSTOMIZATION.VALIDATION.BODY_COLOR_REQUIRED' | translate }}
        </div>
      </div>

      <!-- Sleeve Toggle -->
      <div class="mb-4 d-flex align-items-center">
        <span class="sleeve" id="withSleeve" [ngClass]="{ active: shirtSelections.isSleeve }"
          (click)="toggleSleeve((shirtSelections.isSleeve = !shirtSelections.isSleeve))"></span>
        <label class="form-label mx-2 mb-0" for="withSleeve">{{ 'CUSTOMIZATION.JERSEY.WITH_SLEEVE' | translate
          }}</label>
      </div>

      <!-- Sleeve Colors -->
      <div class="mb-4" *ngIf="shirtSelections.isSleeve">
        <label class="form-label">{{ 'CUSTOMIZATION.JERSEY.SLEEVE' | translate }}</label>
        <div class="d-flex flex-wrap gap-2">
          <span [id]="color + '-sleeve'" *ngFor="let color of colors" [ngStyle]="{ background: color }"
            class="color-circle" [ngClass]="{ active: shirtSelections.sleeveColor === color }"
            (click)="applySleeveColor(color)"></span>
        </div>
        <div *ngIf="hasError('SHIRT.SLEEVE_COLOR_REQUIRED')" class="text-danger mt-2">
          {{ 'CUSTOMIZATION.VALIDATION.SLEEVE_COLOR_REQUIRED' | translate }}
        </div>
      </div>

      <!-- Body Logo -->
      <div class="mb-4">
        <label class="form-label">{{ 'CUSTOMIZATION.JERSEY.BODY_LOGO' | translate }}</label>
        <div class="d-flex flex-wrap gap-2">
          <span [id]="color + '-logo'" *ngFor="let color of colors" [ngStyle]="{ background: color }"
            class="color-circle" [ngClass]="{ active: shirtSelections.logoColor === color }"
            (click)="applyLogoColor(color)"></span>
        </div>
        <div *ngIf="hasError('SHIRT.LOGO_COLOR_REQUIRED')" class="text-danger mt-2">
          {{ 'CUSTOMIZATION.VALIDATION.LOGO_COLOR_REQUIRED' | translate }}
        </div>
      </div>

      <!-- Shoulder Logo -->
      <div class="mb-2">
        <label class="form-label">{{ 'CUSTOMIZATION.JERSEY.SHOULDER_LOGO_COLOR' | translate }}</label>
        <div class="d-flex flex-wrap gap-2">
          <span [id]="color + '-shoulderLogoColor'" *ngFor="let color of colors" [ngStyle]="{ background: color }"
            class="color-circle" [ngClass]="{ active: shirtSelections.shoulderLogoColor === color }"
            (click)="applyShoulderLogoColor(color)"></span>
        </div>
        <div *ngIf="hasError('SHIRT.SHOULDER_LOGO_COLOR_REQUIRED')" class="text-danger mt-2">
          {{ 'CUSTOMIZATION.VALIDATION.SHOULDER_LOGO_COLOR_REQUIRED' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>